import { LinearProgress } from '@mui/material';
import React, { useState } from 'react'
import databaseUpdateServices from '../databaseUpdateServices';
import FinanceLayout from '../../../../../../layout/components/FinanceLayout';

function DatabaseUpdateScriptsPage() {

  const [loading,setLoadingStatus] = useState(false);

  const [addressFieldUpdateResponse,setAddressFieldUpdateResponse] = useState(null);

  const updateAddressFields = () =>{
    // Date 29 -October -2026
    setLoadingStatus(true);
    setAddressFieldUpdateResponse(null);

    databaseUpdateServices.updateAddressColumns().then(res=>{
      setAddressFieldUpdateResponse(res);
    }).catch(e=>{
      setAddressFieldUpdateResponse(e);
    }).finally(()=>{
      setLoadingStatus(false);
    })

  }

  return (
    <FinanceLayout>
        <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className='card my-2'>
                  <div className='card-header'>
                    {!loading ?
                      <button className='btn btn-outline-primary' onClick={updateAddressFields} > Update Address Fields</button>
                      :
                      <LinearProgress/>
                    }
                  </div>
                  <div className='card-body'>
                    {loading && <LinearProgress/>}
                    {addressFieldUpdateResponse && !loading &&
                      <pre>
                        {JSON.stringify(addressFieldUpdateResponse, null, 2)}
                      </pre>
                    }
                  </div>
					      </div>
              </div>
            </div>
        </div>
    </FinanceLayout>
  )
}

export default DatabaseUpdateScriptsPage